import React from 'react';

const BoxButton = ({
	children,
	onClick = () => {},
}: {
	children: React.ReactNode;
	onClick?: () => void;
}) => {
	return (
		<button
			className='absolute bg-light top-4 right-4 flex justify-center items-center rounded-full p-2 bg-light h-7 w-7 transition-all duration-300 border border-tertiary focus:outline-none'
			aria-label='Apply Filters'
			onClick={onClick}
		>
			{children}
		</button>
	);
};

export default BoxButton;
